
/*
 * Synchronizes the model and view values for the timepicker widget. Populate the ng-model with a object whose
 * 'h' property is the number of hours, and 'm' property is minutes in accordance with Javscript Date object.
 * Given an object of the above kind it populates the timepicker with the respective time.
 *
 *  Time format validation for editable timepickers is also included.
 *
 * Required Files:
 * "lib/jquery/timepicker/jquery.timepicker.js"
 */
angular.module('jv.Common.Directives.Timepicker', [])

.directive('jvTimepicker', [function() {
    return {
        require: '?ngModel',
        link: function(scope, elm, attrs, controller) {
            elm.timepicker({timeFormat: 'g:i A', step: 15});
            elm.on('change blur', function(){
                scope.$apply(function(){
                    if(elm.val() ||  elm[0].defaultValue){
                        var updatedTime = (controller.$viewValue !== elm.val() || (controller.$viewValue === elm.val() && !elm[0].defaultValue)) ? elm.val() : elm[0].defaultValue;
                        controller.$setViewValue(updatedTime);
                        controller.$render();
                    }
                });
            });

            controller.$parsers.unshift(function(viewValue){
                var obj = {}, pm = false, delimIndex, re = /^(?:0?\d|1[012]):[0-5]\d\s[A|P]M$/;
                if(!angular.isString(viewValue)){
                    return;
                }
                if(!viewValue.match(re)){
                    controller.$setValidity('format', false);
                    return;
                }else{
                    controller.$setValidity('format', true);
                }
                delimIndex = viewValue.indexOf(':');
                obj.h = parseInt(viewValue.substring(0, delimIndex));
                obj.m = parseInt(viewValue.substring(delimIndex+1, delimIndex+3));

                pm = viewValue.substring(viewValue.length-2, viewValue.length).toLowerCase() === 'pm';
                if(pm){
                    if(obj.h != 12){
                        obj.h += 12;
                    }
                }else if(obj.h === 12){
                    obj.h = 0;
                }
                return obj;
            });

            controller.$formatters.unshift(function(modelValue){
                var hours, res;
                if(!modelValue || typeof modelValue.h === 'undefined' || typeof modelValue.m === 'undefined'){
                    return;
                }
                hours = modelValue.h;
                if(angular.isObject(modelValue)){
                    if(hours === 0){
                        hours = 12;
                    } else if(hours > 12){
                        hours = hours -12;
                    }
                    res = hours + ':' + (modelValue.m<10?'0'+modelValue.m:modelValue.m )+  (modelValue.h>11?' PM':' AM');
                    return res;
                }
            });
        }
    };
}]);
